import { __rest } from 'tslib';
import React from 'react';
import { FontWeight } from '../../../styles/theme.mjs';
import agnosticStyled from '../../../utils/agnosticStyled.mjs';
import styled from 'styled-components';

const StyledHeading = agnosticStyled `
  font-weight: ${props => { var _a; return props.theme.typography.fontWeight[(_a = props.fontWeight) !== null && _a !== void 0 ? _a : FontWeight.Medium]; }};
  color: ${props => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.textColor; }};
  font-size: ${props => { var _a; return (_a = props.theme.typography.headings[props.tag]) === null || _a === void 0 ? void 0 : _a.fontSize; }};
  line-height: ${props => { var _a; return (_a = props.theme.typography.headings[props.tag]) === null || _a === void 0 ? void 0 : _a.lineHeight; }};
  margin-top: ${props => ({
    h1: '0.67em',
    h2: '0.83em',
    h3: '1em',
    h4: '1.33em',
    h5: '1.67em',
    h6: '2.33em'
}[props.tag])};
  margin-bottom: 1.5rem;
  text-transform: ${props => (props.uppercase ? 'uppercase' : 'none')};
`;
const StyledH5 = styled(StyledHeading) `
  font-weight: ${props => props.theme.typography.fontWeight.semibold};
`;
const StyledH6 = styled(StyledHeading) `
  font-weight: ${props => props.theme.typography.fontWeight[props.fontWeight || FontWeight.Medium]};
  margin: 0;
`;
const Heading = (props) => {
    const { tag, children } = props, stylesProps = __rest(props, ["tag", "children"]);
    switch (tag) {
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
            return (React.createElement(StyledHeading, Object.assign({ tag: tag }, stylesProps), children));
        case 'h5':
            return (React.createElement(StyledH5, Object.assign({ tag: tag }, stylesProps), children));
        case 'h6':
            return (React.createElement(StyledH6, Object.assign({ tag: tag }, stylesProps), children));
        default:
            return (React.createElement(StyledHeading, Object.assign({ tag: tag }, stylesProps), children));
    }
};

export { StyledHeading, Heading as default };
//# sourceMappingURL=Heading.mjs.map
